
import ContextMenu from 'devextreme/ui/context_menu';
import { saveTXT, collectFilters, countNumberTranscriptsByFilters } from '../utils'
import { store } from '../../../store/configureStore'

export default function getOnContextMenuPreparing({
  texts, account, removeTranscripts, trySendToEmail, dataGridRef,
}) {
  return event => {
    if (event.target !== 'content') return

    const totalCount = store.getState().transcriptViewer.totalCount
    const { selectionFilter } = collectFilters({ dataGridRef })
    const numberSelectedTranscripts = countNumberTranscriptsByFilters(selectionFilter, totalCount)
    if (numberSelectedTranscripts > 1) return

    const { data: transcript } = event.row
    event.items = event.items || []
    event.items = event.items.concat([{
      text: texts['remove'],
      onItemClick: () => {
        removeTranscripts(['transcriptId', '=', transcript.transcriptId])
      },
      icon: 'trash',
    }, {
      text: texts['contextmenu-export-txt'],
      onItemClick: () => {
        saveTXT({ transcripts: [transcript], texts, accountName: account.accountName })
      },
      icon: 'txtfile',
    }, {
      text: texts['send-to-email_title'],
      onItemClick: () => {
        trySendToEmail(transcript.transcriptId)
      },
      icon: 'exportselected',
    }])
    selectAndDeselectRow(event)
  }
}

const CONTEXT_MENU_TARGET = 'contextMenuTarget'

function selectAndDeselectRow(event) {
  const row = getRowRecursively(event.targetElement)
  const menu = event.element.querySelector('.dx-context-menu');
  const menuInstance = ContextMenu.getInstance(menu)
  if (!menuInstance) return

  /* select */
  row.classList.add(CONTEXT_MENU_TARGET)
  /* deselect */
  menuInstance.option('onHiding', () => {
    row.classList.remove(CONTEXT_MENU_TARGET)
  });
}

function getRowRecursively(element) {
  const { parentElement } = element
  const isRow = ~parentElement.className.indexOf('dx-data-row')
  return isRow ? parentElement : getRowRecursively(parentElement)
}
